import { useContext, useEffect, useState } from "react"
import { useNavigate, useNavigation, useSearchParams } from "react-router-dom"
import Header from "../../../header/header"
import Footer from "../../../footer/footer"
import Card from "../../../../components/card/card"
import { claimProduct, productDetail, productList } from "../../service"
import { toast } from "react-toastify"
import CustomButton from "../../../../components/button"
import { useDispatch } from "react-redux"
import { updateTotalSavings } from '../../../../../store/slices/categorySlice'
import { routerPath } from "../../../../navigation/path";


const ClaimOffer = () => {
    const navigate = useNavigate()
    const [offer, setOffer] = useState({})
    const [uniqueCode, setUniqueCode] = useState({})
    const [searchParams] = useSearchParams()
    const [offerId, setOfferId] = useState(searchParams.get('offer_id'))
    const [instructionType, setInstructionType] = useState('claim')
    const [loader, setLoader] = useState(false)
    const [product, setProduct] = useState([])

    const dispatch = useDispatch()

    useEffect(() => {
        offerDetail()
    }, [offerId])


    const offerDetail = async () => {
        try {
            const res = await productDetail({ product_id: offerId })
            setOffer(res?.data)
            setUniqueCode(res?.order)
            getProductByCat(res?.data?.category.id)
            console.log(res)
        } catch (err) {

        }
    }

    const claimNow = async () => {
        try {
            let payload = {
                product_id: offerId
            }

            setLoader(true)
            const res = await claimProduct(payload)
            console.log(res);
            setLoader(false)
            await dispatch(updateTotalSavings(res?.total_saving))
            toast.success(res?.message)
            offerDetail()
        } catch (err) {
            setLoader(false)
            console.log(err);
        }
    }

    const copyContent = async () => {
        await navigator.clipboard.writeText(uniqueCode?.unique_code);
        toast.success('Copied to clipboard successfully !')
    }

    const getProductByCat = async (cat_id) => {
        try {
            const res = await productList({ cat_id: cat_id == null ? '' : cat_id, product_type: 1 })
            console.log(res)
            setProduct(res?.data)
        } catch (err) {
            console.log(err)
        }
    }


    return (
        <>

            <div className="bg-[#f1f1f1]">
                <Header />
                <div className="lg:w-[75vw] sm:[w-94%] m-auto py-5">
                    <div className="grid lg:grid-cols-7 sm:grid-cold-1 p-3 bg-white rounded">
                        <div className="lg:col-span-2 w-[100%] pr-5">
                            <img src={offer?.image1} alt="" className="w-[100%] rounded" />
                        </div>
                        <div className="lg:col-span-3 py-3 sm:py-3">
                            <h6 className="font-bold">
                                {offer?.name}
                            </h6>
                            <p className="text-sm mb-1">
                                {offer?.short_description}
                            </p>
                            <p className="text-sm mb-1">
                                {offer?.description}
                            </p>
                            <p className="text-sm mb-1">
                                Offer valid till {offer?.validity_end_date}
                            </p>
                            {/* <p className="text-sm mb-0">
                                Categories: , AssortedTop Brands
                            </p> */}
                        </div>
                        <div className="lg:col-span-2 sm:text-right pl-10">
                            {
                                uniqueCode?.unique_code ?
                                    <div className="border border-yellow-800 flex h-[50px] rounded overflow-hidden">
                                        <div className="w-[70%] px-3 flex items-center">
                                            <p className="text-md font-semibold mb-0">
                                                {uniqueCode?.unique_code}
                                            </p>
                                        </div>
                                        <div className="w-[30%] px-3 flex items-center justify-center bg-yellow-500 cursor-pointer" onClick={copyContent}>
                                            <p className="mb-0">
                                                COPY
                                            </p>
                                        </div>
                                    </div>
                                    :
                                    <CustomButton title='CLAIM NOW!' loader={loader} buttonStyle="border border-[#0673EA] py-2 px-4 rounded" onClick={claimNow} />

                            }
                        </div>

                    </div>
                    <div className="grid lg:grid-cols-5 grid-cols-1 my-4 bg-white rounded p-3 gap-3" >
                        <div className="sm:col-span-1 col-span-5">
                            <button className={`block  p-2   w-[100%] rounded-t-l mb-[2px] ${instructionType == 'claim' ? 'bg-[#0673EA] text-white' : 'bg-[#f3f3f3] text-black'}`} onClick={() => setInstructionType('claim')}>
                                How to Redeem
                            </button>
                            <button className={`block  p-2   w-[100%] mb-[2px] ${instructionType == 'tearms' ? 'bg-[#0673EA] text-white' : 'bg-[#f3f3f3] text-black'}`} onClick={() => setInstructionType('tearms')}>
                                Terms & Conditions
                            </button>
                        </div>
                        <div className="col-span-4">
                            {
                                instructionType == 'claim' ?
                                    <div className="text-bold">
                                        <p dangerouslySetInnerHTML={{ __html: offer?.how_to_redeem }}>

                                        </p>
                                    </div>
                                    :
                                    <div dangerouslySetInnerHTML={{ __html: offer?.t_n_c }}>

                                    </div>
                            }
                        </div>

                    </div>
                    <div className="grid lg:grid-cols-4 sm:grid-cols-1">
                        {
                            product.map((e, i) =>
                                <div className="px-2 overflow-hidden" key={i}>
                                    <Card cardType='Heading' img={e?.image1} title={e?.name} click={() => setOfferId(e.id)} />
                                </div>
                            )
                        }
                    </div>
                </div>
                <Footer />

            </div>
        </>
    )
}

export default ClaimOffer

